import React from 'react';
import { Modal, Box, Link, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { BasicPortableText } from 'src/components';

interface ModalLinkProps {
  children: React.ReactNode;
  value?: {
    modalLink: {
      _type: 'modal';
      content: any;
    };
  };
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxHeight: '90%',
  width: ['90%', '80%', '60%'],
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '5px',
  boxShadow: 24,
  p: 4,
  pt: 6,
};

const closeButtonStyle = {
  position: 'absolute' as 'absolute',
  top: 8,
  right: 8,
};

const contentStyle = {
  maxHeight: 'calc(90vh - 100px)', // Adjust the height calculation as necessary
  overflowY: 'auto',
};

const ModalLink = ({ children, value }: ModalLinkProps) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Link onClick={handleOpen} color="inherit" sx={{ cursor: 'pointer' }}>
        {children}
      </Link>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <IconButton sx={closeButtonStyle} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
          <Box sx={contentStyle}>            
            <BasicPortableText content={value?.modalLink?.content} />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ModalLink;
